/* import __COLOCATED_TEMPLATE__ from './get-started.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();